const Fallback = () => (
    <svg
        width='115'
        height='115'
        viewBox='0 0 115 115'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle
            cx='57.5'
            cy='57.5'
            r='57'
            fill='url(#paint0_linear_3329_3073)'
            stroke='url(#paint1_linear_3329_3073)'
        />
        <path
            opacity='0.7'
            d='M57.0367 69.7066C55.5688 69.7066 54.3308 69.1867 53.3229 68.147C52.3125 67.1072 51.8684 65.884 51.9908 64.4772C52.1743 61.9084 52.7859 59.676 53.8256 57.78C54.8654 55.8839 56.5168 53.9267 58.7798 51.9084C61.2874 49.7065 63.1982 47.7946 64.5119 46.1726C65.8281 44.553 66.4862 42.7035 66.4862 40.6239C66.4862 38.1163 65.6459 36.0368 63.9651 34.3854C62.2819 32.734 59.9419 31.9083 56.9449 31.9083C54.9877 31.9083 53.3217 32.3205 51.9467 33.145C50.5694 33.9719 49.4525 34.997 48.5963 36.2202C47.74 37.4435 46.6855 38.2692 45.4329 38.6973C44.1779 39.1255 42.9693 39.0949 41.8072 38.6056C40.4005 37.994 39.4378 36.9848 38.9192 35.578C38.398 34.1713 38.5045 32.8563 39.2384 31.6331C41.0121 28.8808 43.3975 26.5872 46.3944 24.7523C49.3914 22.9174 52.9082 22 56.9449 22C63.367 22 68.3064 23.7896 71.7633 27.3688C75.2178 30.9456 76.945 35.2416 76.945 40.257C76.945 43.3151 76.2881 45.9304 74.9744 48.1029C73.6581 50.2729 71.5933 52.7341 68.7798 55.4864C66.7003 57.4436 65.2324 59.0338 64.3761 60.257C63.5199 61.4803 62.9388 62.887 62.633 64.4772C62.3884 66.0063 61.7462 67.2601 60.7064 68.2387C59.6666 69.2173 58.4434 69.7066 57.0367 69.7066ZM56.9449 91.7251C54.9266 91.7251 53.1993 91.007 51.7632 89.5709C50.3247 88.1324 49.6054 86.4039 49.6054 84.3856C49.6054 82.3672 50.3247 80.6388 51.7632 79.2002C53.1993 77.7642 54.9266 77.0461 56.9449 77.0461C58.9633 77.0461 60.6917 77.7642 62.1303 79.2002C63.5664 80.6388 64.2844 82.3672 64.2844 84.3856C64.2844 86.4039 63.5664 88.1324 62.1303 89.5709C60.6917 91.007 58.9633 91.7251 56.9449 91.7251Z'
            fill='white'
        />
        <defs>
            <linearGradient
                id='paint0_linear_3329_3073'
                x1='17.819'
                y1='-29.7084'
                x2='126.613'
                y2='-1.74459'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#051650' stopOpacity='0.04' />
                <stop offset='1' stopColor='#00FFFF' stopOpacity='0.24' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_3329_3073'
                x1='2.2461'
                y1='-46.9583'
                x2='129.418'
                y2='-24.1975'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='white' stopOpacity='0.81' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0.37' />
            </linearGradient>
        </defs>
    </svg>
);

export default Fallback;
